/* eslint-disable @typescript-eslint/no-unsafe-function-type */
import { useMemoize } from "@vueuse/core";

// 获取批次列表
const getBatches = useMemoize(
  async (params: {
    company_id?: number;
    domain?: string;
    page?: number;
    page_size?: number;
    status?: string;
  }) => {
    const { $myFetch } = useNuxtApp();
    const { getCurrentDomain } = useCompany();
    
    // 如果没有传递domain，则使用当前域名
    let domain = params.domain;
    if (!domain && !params.company_id) {
      domain = getCurrentDomain();
    }
    
    const queryParams = new URLSearchParams();
    if (params.company_id) {
      queryParams.append('company_id', params.company_id.toString());
    }
    if (domain) {
      queryParams.append('domain', domain);
    }
    if (params.page) {
      queryParams.append('page', params.page.toString());
    }
    if (params.page_size) {
      queryParams.append('page_size', params.page_size.toString());
    }
    if (params.status) {
      // queryParams.append('status', params.status);
    }
    
    return await ($myFetch as Function)(`/api/batches?${queryParams.toString()}`);
  }
);

// 验证员工资格（支持非SJK渠道）
const verifyEmployee = async (params: {
  company_id: number;
  batch_id: number;
  employee_name: string;
  employee_code: string;
}) => {
  const { $myFetch } = useNuxtApp();
  
  return await ($myFetch as Function)('/api/evaluations/verify', {
    method: 'POST',
    body: params
  });
};

// 验证SJK渠道资格
const verifySJKEvaluation = async (params: {
  company_id: number;
  batch_id: string | number;
  sub: string;
  call_url?: string;
  user_name?: string;
}) => {
  const { $myFetch } = useNuxtApp();
  
  return await ($myFetch as Function)('/api/evaluations/verify', {
    method: 'POST',
    body: params
  });
};

// 通用验证接口，根据参数类型自动选择验证方式
const verifyEvaluation = async (params: Record<string, unknown>) => {
  if (params.sub) {
    // SJK渠道验证
    return await verifySJKEvaluation(params as Parameters<typeof verifySJKEvaluation>[0]);
  } else {
    // 普通员工验证
    return await verifyEmployee(params as Parameters<typeof verifyEmployee>[0]);
  }
};

export function useEvaluation() {
  return {
    getBatches,
    verifyEmployee,
    verifySJKEvaluation,
    verifyEvaluation
  };
} 
